import * as ko from "knockout";
import { PdfApi } from "../Apis/PdfApi";
import { EReportType } from "../Models/Pdf/ReportType";
import { PdfInfo } from "../Models/Pdf/PdfInfo";
import { groupBy, map, orderBy, forEach, isEmpty  } from "lodash-es";
import { SettlementPriceYearList } from "../Models/Pdf/SettlementPriceYearList";
import { SettlementPrices } from "../components/SettlementPrices";
import { SettingsApi } from "../Apis/SettingsApi";
import "footable-npm";

export class SettlementPricesViewModel {
    pdfApi: PdfApi;
    settlementPrices = ko.observableArray<PdfInfo>();
    private $content: JQuery;
    private expirationDate: Date;
    loading = ko.observable<boolean>(true);

    isNew(date: Date) {
        return date > this.expirationDate;
    }

    constructor() {
        SettingsApi.getInstance().getExpirationDate().then(res => this.expirationDate = res);
        this.pdfApi = PdfApi.getInstance();
        this.$content = $(".pdf-content");

        //Subscribe to subset of crops change to keep footable up to date.
        this.settlementPrices.subscribe(() => {
            ($('.toBeFoo') as any).footable();
        });

    }

    init(): void {
        this.pdfApi.getPdfsByType(EReportType.SettlementPrices).then((res) => {
            this.settlementPrices(orderBy(res, x => (x as PdfInfo).FileName));
            //console.log(res);
            this.delay(150).then(() => {
                this.loading(false);
                this.$content.removeClass("d-none");
                this.$content.css("display", "inline");
            });
        });
    }


    /*
     * Collection used for the graphic table representations.
     */
    private groupedByYear: KnockoutComputed<SettlementPriceYearList[]> = ko.computed(() => {

        let list = new Array<SettlementPriceYearList>();
        var tmp = this.settlementPrices();
        var groupedList = groupBy(
            orderBy(this.settlementPrices(), c => c.DateAndTime, 'desc'),
            (item) => {
                return new Date(item.DateAndTime).getFullYear();
            }
        );
        forEach(groupedList, e => {
            const year = new Date(e[0].DateAndTime).getFullYear();
            list.push(new SettlementPriceYearList(year, e));
        });

        return orderBy(list, c => c.Year, 'desc');
    });

    private delay(ms: number) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }
}